<template>
  <div>
    <Card style="width: 400px;">
      <p slot="title">
        <Icon type="ios-call" />
        客服电话维护
      </p>
      <Form ref="phoneForm" :model="formData" :rules="rules" :label-width="80">
        <FormItem label="客服电话" prop="phone">
          <Input v-model="formData.phone" placeholder="请输入客服电话" />
        </FormItem>
        <FormItem>
          <Button type="primary" @click="handleSubmit">保存</Button>
          <Button style="margin-left: 8px" @click="handleReset">重置</Button>
        </FormItem>
      </Form>
    </Card>
  </div>
</template>

<script>
import { getServicePhone, updateServicePhone } from '@/api/home'

export default {
  name: 'Other',
  data() {
    return {
      formData: {
        phone: ''
      },
      rules: {
        phone: [
          { required: true, message: '请输入客服电话', trigger: 'blur' },
          { pattern: /^1[3-9]\d{9}$/, message: '请输入正确的手机号码', trigger: 'blur' }
        ]
      }
    }
  },
  created() {
    this.getPhone()
  },
  methods: {
    async getPhone() {
      try {
        const res = await getServicePhone()
        if (res.data.code === 200) {
          this.formData.phone = res.data.data.phone
        } else {
          this.$Message.error(res.data.msg)
        }
      } catch (error) {
        this.$Message.error('获取电话失败')
      }
    },
    handleSubmit() {
      this.$refs.phoneForm.validate(async valid => {
        if (valid) {
          try {
            const res = await updateServicePhone(this.formData)
            if (res.data.code === 200) {
              this.$Message.success('保存成功')
            } else {
              this.$Message.error(res.data.msg)
            }
          } catch (error) {
            this.$Message.error('保存失败')
          }
        }
      })
    },
    handleReset() {
      this.$refs.phoneForm.resetFields()
      this.getPhone()
    }
  }
}
</script>

<style scoped>

</style>